import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { get, getForUrl } from "../../api";
import { page_limit_blog } from "utils";
const { BLOGS } = Routes;

/*******************
@purpose :  get blog list
@Parameter : {}
@Author : INIC
******************/
export const getBlogList = () => (dispatch) => {
  return get(`${BLOGS}?page_limit=${page_limit_blog}`, false).then((res) => {
    if (res?.data) {
      return res;
    }
    return Promise.reject(res);
  });
};
/*******************
@purpose :  get blog details
@Parameter : {}
@Author : INIC
******************/
export const getBlogDetail = (slug) => (dispatch) => {
  return get(`${BLOGS}/${slug}`, false).then((res) => {
    if (res?.data) {
      dispatch(setBlogMetaData(res.data));
      return res.data;
    }
    return Promise.reject(res);
  });
};
/*******************
@purpose :  Get load more data of blog
@Parameter : {}
@Author : INIC
******************/
export const getBlogLoadMoreData = (url) => (dispatch) => {
  return getForUrl(`${url}&page_limit=${page_limit_blog}`, false, false).then(
    (res) => {
      if (res?.data) {
        return res;
      }
      return Promise.reject(res);
    }
  );
};

/********************
@purpose : clear blog list
@Parameter : { data }
@Author : INIC
******************/
export const clearBlogList = (data) => {
  return {
    type: types.SET_BLOG_LIST_CLEAR,
    data,
  };
};

/********************
@purpose : set blog list
@Parameter : { data }
@Author : INIC
******************/
export const setBlogList = (data) => {
  return {
    type: types.SET_BLOG_LIST,
    data,
  };
};

/********************
@purpose : set blog meta data
@Parameter : { data }
@Author : INIC
******************/
export const setBlogMetaData = (data) => {
  return {
    type: types.SET_BLOG_META_DATA,
    data,
  };
};

/********************
@purpose : set total record for blog list
@Parameter : { data }
@Author : INIC
******************/
export const setBlogTotalRecord = (data) => {
  return {
    type: types.SET_BLOG_TOTAL_RECORD,
    data,
  };
};
